// pages/Videos.js
import React, { useEffect, useState } from 'react';
import '../styles/VideoSection1.css';
import Carousel from '../components/Carousel';


function Videos() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [filter, setFilter] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
{ id: 1, title: '"أنا سارة صحفية (…)" - شهادة 1', description: 'قصة حقيقية لامرأة تعرضت للابتزاز الإلكتروني وكيف تغلبت على محنتها', thumbnail: '/images/all.jpg', category: 'عنف رقمي',   youtubeId: '87Wo3E5qbd8' },
{ id: 2, title: 'هاجر، صديقة ضحية انتحار - شهادة 2', description: 'سلسلة شهادات مستوحاة من وقائع مرصودة، بالفضاء الرقمي وخارجه', thumbnail: '/images/all.jpg', category: 'عنف رقمي يؤدي للانتحار' ,   youtubeId: 'LOWTTDcLskI' },

  ];

  const categories = [
    'all',
    'عنف رقمي يؤدي للانتحار',
    'الابتزاز الرقمي',
    'حماية الخصوصية',
    'سلامة الإنترنت',
    'تحرش رقمي',
    'تحريض على العنف',
    'عنف رقمي'
  ];

  const filteredVideos = filter === 'all'
    ? videos
    : videos.filter(video => video.category === filter);

  // Fonctions pour le modal
  const openVideoModal = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeVideoModal();
    };

    if (selectedVideo) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [selectedVideo]);

  return (
    <div className="videos-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>
          <img
            src="/images/Asset6.png"
            alt="Videos Icon"
            style={{ width: '80px', height: '80px', objectFit: 'contain' }}
          />
          <h1 style={{
            fontSize: '3.5rem',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
          شهادات
          </h1>
          <p style={{ fontSize: '1.3rem', color: 'var(--text-light)', maxWidth: '700px', margin: '0 auto' }}>
شهادات مستوحاة من قصص حقيقية وقصص مرصودة بالفضاء الرقمي. الأسماء غير حقيقية
            </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">
          {/* Filter Section */}
          <div style={{ marginBottom: '50px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.8rem', marginBottom: '25px', color: 'var(--white)' }}>
              حسب الفئة
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  style={{
                    padding: '12px 30px',
                    borderRadius: '25px',
                    border: filter === category ? '2px solid var(--primary-orange)' : '2px solid rgba(255, 107, 53, 0.3)',
                    background: filter === category ? 'var(--primary-orange)' : 'var(--primary-black)',
                    color: 'var(--white)',
                    fontSize: '1.1rem',
                    fontWeight: filter === category ? '700' : '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    fontFamily: 'Cairo, sans-serif'
                  }}
                  onMouseEnter={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'var(--primary-orange)';
                      e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                      e.target.style.background = 'var(--primary-black)';
                    }
                  }}
                >
                  {category === 'all' ? 'الكل' : category}
                </button>
              ))}
            </div>
            <p style={{ marginTop: '20px', fontSize: '1.1rem', color: 'var(--text-light)' }}>
              عرض {filteredVideos.length} من {videos.length} شهادة
            </p>
          </div>

          {/* Videos Grid avec modal */}
          <div className="video-grid">
            {filteredVideos.map((video) => (
              <div key={video.id} className="video-card">
                <div
                  className="video-thumbnail"
                  onClick={() => openVideoModal(video)}
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="play-button"></div>
                </div>
                <div className="video-info">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h3 className="video-info-title" style={{ margin: 0 }}>{video.title}</h3>
                    <span style={{
                      padding: '5px 12px',
                      background: 'rgba(255, 107, 53, 0.2)',
                      borderRadius: '15px',
                      fontSize: '0.85rem',
                      color: 'var(--primary-orange)',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}>
                      {video.category}
                    </span>
                  </div>
                  <p className="video-info-description">{video.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Modal Video */}
          {selectedVideo && (
            <div
              className="video-modal-overlay"
              onClick={closeVideoModal}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
            >
              <div
                className="video-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'relative',
                  width: '90%',
                  maxWidth: '1200px',
                  backgroundColor: 'var(--primary-black)',
                  borderRadius: '15px',
                  padding: '20px'
                }}
              >
                <button
                  onClick={closeVideoModal}
                  style={{
                    position: 'absolute',
                    top: '-15px',
                    right: '-15px',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    border: 'none',
                    background: 'var(--primary-orange)',
                    color: 'white',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 1001
                  }}
                  aria-label="Fermer"
                >
                  ×
                </button>
                <div className="video-player-wrapper" style={{ position: 'relative', paddingTop: '56.25%' }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1&rel=0`}
                    title={selectedVideo.title}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          )}

          {/* No Results */}
          {filteredVideos.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-light)' }}>
              <h3 style={{ fontSize: '2rem', marginBottom: '15px' }}>لا توجد شهادات في هذه الفئة</h3>
              <p style={{ fontSize: '1.2rem' }}>جرب فئة أخرى أو اختر "الكل" لعرض جميع الشهادات</p>
            </div>
          )}






    </div>
  </div>

  {/* Footer Note */}
  <div style={{
    background: 'var(--secondary-black)',
    padding: '30px 0',
    textAlign: 'center',
    borderTop: '1px solid rgba(255, 107, 53, 0.2)'
  }}>
  </div>
    <Carousel />
</div>
);
}

export default Videos;
